import React, { useState } from 'react';
import '../components.scss';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import AddNewSkill from './AddNewSkill';
import OneSkillItem from './SkillTable';

function SkillList() {
  const [showModal, setShowStatement] = useState(false);
  const show = () => {
    setShowStatement(!showModal);
  };
  return (
    <div>
      <div className="skillsBox">
        <Button
          type="button"
          onClick={() => { show(); }}
          variant="outline-info"
          className="main-button"
        >
          Add skill
        </Button>
        <OneSkillItem />
      </div>
      <AddNewSkill show={() => { show(); }} isOpen={showModal} />
    </div>
  );
}
const mapStateToProps = (state) => ({
  taskList: state.skillsReducer.skillList,
});

export default connect(mapStateToProps,
  {})(SkillList);
